import React, { useContext, useEffect } from "react";
import Navbar from '../components/Navbar';
import Carousel from '../components/Carousel';
import About from '../components/about/about_body';
import Topbar from '../components/Topbar';
import { LanguageContext } from "../context/LanguageContext";

const Page = () => {
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);
    
  useEffect(() => {
      loadLanguageFile("About", "about/about_body_lang"); // ✅
  }, [language]);
  const LANGUAGE = componentLanguageData.About || { Main: {} };
  return (
    <div>
      <title>{LANGUAGE.Main.Title}</title>
      <Topbar />
      <Navbar />
      <Carousel />
      <About />
    </div>
  );
};

export default Page;